export default "__VITE_ASSET__f86ce4b8__"